export default __webpack_public_path__ + "static/media/customer-service-support-agent-animation.6a5cb27e.gif";